'use client'

import React, { createContext, useContext, useMemo, useState } from 'react'

type EditorUIState = {
  selectedRowId: string | null
  setSelectedRowId: (id: string | null) => void
  selectedModuleId: string | null
  setSelectedModuleId: (id: string | null) => void
  clearSelection: () => void
}

const EditorUICtx = createContext<EditorUIState | null>(null)

export function EditorUIProvider({ children }: { children: React.ReactNode }) {
  const [selectedRowId, setSelectedRowId] = useState<string | null>(null)
  const [selectedModuleId, setSelectedModuleId] = useState<string | null>(null)

  const value = useMemo(
    () => ({
      selectedRowId,
      setSelectedRowId,
      selectedModuleId,
      setSelectedModuleId,
      clearSelection: () => {
        setSelectedModuleId(null)
        setSelectedRowId(null)
      },
    }),
    [selectedRowId, selectedModuleId]
  )

  return <EditorUICtx.Provider value={value}>{children}</EditorUICtx.Provider>
}

export function useEditorUI() {
  const v = useContext(EditorUICtx)
  if (!v) throw new Error('useEditorUI must be used within <EditorUIProvider />')
  return v
}